const storage = {
  set: (key, value) => window.localStorage.setItem(key, JSON.stringify(value)),
  get: (key) => JSON.parse(window.localStorage.getItem(key)),
  remove: (key) => window.localStorage.removeItem(key),
};

function checkUrlParams(key, expectedValue) {
  const currentUrl = new URL(window.location.href);
  const hasKey = currentUrl.searchParams.has(key);
  let value = null;

  if (hasKey) {
    value = currentUrl.searchParams.get(key);
    currentUrl.searchParams.delete(key);
    window.history.pushState({}, '', currentUrl.toString());
  }

  if (expectedValue === undefined) {
    return value || null;
  }
  return value === expectedValue;
}

function getUserStatus(url) {
  return fetch(url)
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Server responded with status: ' + response.status);
      }
      return response.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (err) {
      console.log('Error', err);
      return null;
    });
}

function displayInfoStatus(art) {
  getUserStatus(
    art.querySelector('.form--voting').getAttribute('data-status-url')
  )
    .then(function (data) {
      const { loggedIn, registered, voted } = data;

      let status;
      if (voted) {
        status = 'voted';
      } else if (registered) {
        status = 'registered';
      } else if (loggedIn) {
        status = 'loggedIn';
      } else {
        status = 'default';
      }

      switch (status) {
        case 'voted':
          art.querySelector('.voting__container').innerHTML =
            typeof voted === 'string'
              ? voted
              : `<div class="article__text">
              <div class="form__completed">
                <h4>Dziękujemy za Twój głos.</h4>
                <p>Dzisiejszy głos w tej kategorii został już oddany, zapraszamy ponownie jutro.</p>
                <a href="https://wszechmocne.wp.pl/kategorie" class="btn-main" data-text="zagłosuj w innej kategorii"></a>
              </div>
            </div>`;
          break;

        case 'registered':
          art.querySelector('.send-data.send-vote').style.display = 'none';
          const firstChild =
            art.querySelector('.form--voting').firstElementChild;
          if (firstChild && firstChild.tagName.toLowerCase() === 'p') {
            firstChild.style.display = 'none';
          }
          art.querySelector('.form__inputs').style.display = 'none';
          art.querySelectorAll('.agrees').forEach(function (el) {
            el.style.display = 'none';
          });
          art.querySelector('.onelogin-info').style.display = 'none';
          break;

        case 'loggedIn':
          art.querySelector('.onelogin-info').style.display = 'none';
          break;

        default:
          break;
      }
    })
    .catch(function (err) {
      console.error('Error:', err);
    });
}

function sendVote(url, data, form) {
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.text())
    .then((serverResponse) => {
      if (
        typeof serverResponse === 'string' &&
        serverResponse.startsWith('http')
      ) {
        storage.set('postOneLoginData', data);
        window.location.href = serverResponse;
      } else {
        // Próba przekształcenia odpowiedzi w HTML i podmiana zawartości
        try {
          document.getElementById('cursor').classList.remove('cursor-btn');
          const vC = form.closest('.voting__container');
          vC.innerHTML = serverResponse;
          startCursor(
            vC.querySelector('.form__completed').querySelectorAll('.btn-main')
          );
          window.sessionStorage.clear();
          window.scrollTo({
            top: window.pageYOffset + vC.getBoundingClientRect().top - 170,
            left: 0,
            behavior: 'smooth',
          });
        } catch (err) {
          console.error('Error parsing HTML response:', err);
        }
      }
    })
    .catch((err) => {
      console.error('Error', err);
    });
}

const goToStep2 = function (av, vc, fv, el, eS) {
  if (av) {
    av.classList.remove('article__voting--hidden');
  }
  if (vc) {
    vc.classList.add('voting__container--step2');
  }
  if (fv) {
    fv.classList.add('form--voting--visible');
  }
  if (el) {
    el.style.display = 'none';
  }
  // wołane niezależnie od av - w części ścieżek article__voting--hidden jest
  // zdejmowane ręcznie przed wywołaniem goToStep2 (av przychodzi wtedy jako null)
  if (window.updateProfileScrollables) {
    window.updateProfileScrollables();
  }
  if (eS) {
    window.scrollTo({
      top: window.pageYOffset + eS.getBoundingClientRect().top - 170,
      left: 0,
      behavior: 'smooth',
    });
  }
};

const handleFormVoting = function () {
  const articlesLoaded = document.querySelectorAll(
    '.article--ajax-wrapper:not(.article--loaded)'
  );
  if (articlesLoaded.length) {
    articlesLoaded.forEach((art) => {
      const cursorModifiers = art.querySelectorAll('.btn-main');
      startCursor(cursorModifiers);
      art.classList.add('article--loaded');

      // artykul kategorii, wybor kandydatki - odsloniecie formularza
      const votingChoice = art.querySelectorAll('.btn-main[data-candidate]');
      if (votingChoice.length) {
        votingChoice.forEach((el) => {
          el.addEventListener('click', function () {
            const candidateId = this.getAttribute('data-candidate');
            const votingContainer = art.querySelector('.voting__container');
            if (!el.classList.contains('profile__item--selected')) {
              art.querySelectorAll('[data-candidate]').forEach((el) => {
                el.classList.remove('profile__item--selected');
              });
              // WYBÓR KANDYDATKI - KLIKNIĘCIE BUTTONA W SEKCJI NOMINOWANE LUB PROFILU W SEKCJI ODDAJ GŁOS
              art
                .querySelectorAll(`[data-candidate="${candidateId}"]`)
                .forEach((el) => {
                  el.classList.add('profile__item--selected');
                });
              // artykul kategorii, wybor kandydatki w sekcji nominowane, odsloniecie formularza
              if (
                votingContainer.querySelectorAll('.profile__item--selected')
                  .length > 0
              ) {
                displayInfoStatus(art);
                art
                  .querySelector('.article__voting')
                  .classList.remove('article__voting--hidden');
                goToStep2(
                  null,
                  votingContainer,
                  votingContainer.querySelector('.form--voting'),
                  null,
                  votingContainer.closest('.article__voting')
                );
              }
            }
          });
        });
      }

      // glosowanie w artykule o danej kandydatce - odsloniecie formularza
      const showBtns = art.querySelectorAll('.show-form');
      if (
        showBtns.length &&
        art.querySelectorAll('.article__voting--hidden').length
      ) {
        showBtns.forEach((el) => {
          el.addEventListener('click', function () {
            displayInfoStatus(art);
            goToStep2(
              art.querySelector('.article__voting--hidden'),
              art.querySelector('.voting__container'),
              art.querySelector('.voting__container .form--voting'),
              el,
              art.querySelector('.article__voting')
            );
          });
        });
      }

      const forms = art.querySelectorAll('.form--voting');
      if (forms.length) {
        forms.forEach((form) => {
          const url = form.getAttribute('data-url');
          const checkboxes = form.querySelectorAll('.form-checkbox');
          const answer = form.querySelector('textarea.form-field');
          // POST 1LOGIN
          const hasPostLogin = checkUrlParams('post_login', '1');
          const postOneLoginData = storage.get('postOneLoginData');
          const hasPostLoginUrl = checkUrlParams('post_login_url');
          const articleWithForm = document.querySelector(
            `article[data-id="${hasPostLoginUrl}"]`
          );
          storage.remove('postOneLoginData');
          // POST EMBED
          const isPostEmbed = checkUrlParams('post_embed', '1');
          const hasPostEmbedCategory = checkUrlParams('category');
          const hasPostEmbedCandidate = checkUrlParams('candidate');
          // dodatkowy warunek url = artykul
          if (hasPostLogin && postOneLoginData && articleWithForm) {
            const postData = Object.assign({}, postOneLoginData, {
              post_login: 1,
            });
            sendVote(
              articleWithForm
                .querySelector('.form--voting')
                .getAttribute('data-url'),
              postData,
              articleWithForm.querySelector('.form--voting')
            );
            setTimeout(function () {
              goToStep2(
                articleWithForm.querySelector('.article__voting--hidden'),
                null,
                null,
                articleWithForm.querySelector('.show-form'),
                articleWithForm.querySelector('.voting__container')
              );
            }, 2000);
          } else if (
            isPostEmbed &&
            hasPostEmbedCategory &&
            hasPostEmbedCandidate
          ) {
            const articlePostEmbed = document.querySelector(
              `article[data-category-name=${hasPostEmbedCategory}]`
            );
            // ?category=dziennikarstwo&candidate=abc&post_embed=1
            form.setAttribute('data-placement', 'embed');
            if (
              articlePostEmbed.querySelector(
                `.article__voting .profile__item[data-candidate-embed="${hasPostEmbedCandidate}"]`
              )
            ) {
              articlePostEmbed
                .querySelector(
                  `.article__voting .profile__item[data-candidate-embed="${hasPostEmbedCandidate}"]`
                )
                .classList.add('profile__item--selected');
              setTimeout(function () {
                goToStep2(
                  articlePostEmbed.querySelector('.article__voting--hidden'),
                  articlePostEmbed.querySelector('.voting__container'),
                  articlePostEmbed.querySelector(
                    '.voting__container .form--voting'
                  ),
                  articlePostEmbed.querySelector('.show-form'),
                  articlePostEmbed.querySelector('.voting__container')
                );
              }, 2000);
            }
          }

          const validateInput = function (input) {
            input.addEventListener('input', function () {
              if (input.closest('fieldset').classList.contains('has-error')) {
                validateField(this, 2);
              }
            });
            input.addEventListener('change', function () {
              validateField(this, 2);
            });
          };

          validateInput(answer);

          checkboxes.forEach((el) => {
            el.addEventListener('change', function () {
              validateCheckbox(this);
            });
          });

          const submitBtns = form.querySelectorAll('.send-vote');

          const data = {};

          // oddanie glosu - wysylanie danych z formularza
          submitBtns.forEach((btn) => {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              let formIsValid = true;
              data.candidate = art
                .querySelector('.profile__item--selected')
                .getAttribute('data-candidate');

              data.category = art.getAttribute('data-category-name');
              // walidacja formularza z danymi

              // BUTTON 1LOGIN
              if (btn.classList.contains('send-data')) {
                if (!validateField(answer, 2)) {
                  formIsValid = false;
                } else {
                  data[answer.getAttribute('data-id')] = answer.value;
                }

                checkboxes.forEach((el) => {
                  if (!validateCheckbox(el)) {
                    formIsValid = false;
                  } else {
                    data[el.getAttribute('data-id')] = el
                      .closest('fieldset')
                      .querySelector('label').innerText;
                  }
                });
                data.button = 'vote_register';
              } else {
                // BUTTON BEZ 1LOGIN - ZOSTAJE BEZ ZMIAN
                // jak cos ma error z fieldstovalidate to usun error
                answer.closest('fieldset').classList.remove('has-error');
                answer.closest('fieldset').setAttribute('data-error', '');
                if (answer.value.trim().length > 0) {
                  data[answer.getAttribute('data-id')] = answer.value;
                }

                checkboxes.forEach((el) => {
                  el.nextElementSibling.classList.remove('has-error');
                  el.classList.remove('has-error');
                  if (el.checked) {
                    data[el.getAttribute('data-id')] = el
                      .closest('fieldset')
                      .querySelector('label').innerText;
                  }
                });
                data.button = 'vote';
              }

              if (formIsValid && data.candidate) {
                createSpinner(form);

                /* FORMULARZ */
                sendVote(url, data, form);
                /* KONIEC FORMULARZA */
              }
            });
          });
        });
      }
    });
  }
};

handleFormVoting();

document.querySelectorAll('.agrees').forEach(function (el) {
  const span = document.createElement('span');
  el.appendChild(span);
});
